/**
 * Whether «دستیار هوشمند» uses the inventory HTTP flow. Vite inlines
 * `VITE_AI_LIVE` when the client is built. A value set only on the API
 * process does not change a bundle that was built without it. A live bundle
 * never falls back to the labelled preview.
 */
export function isAiLive(): boolean {
  return import.meta.env.VITE_AI_LIVE === 'true';
}
